var _a, _b;
import { jsx as _jsx } from "react/jsx-runtime";
import { render } from 'react-dom';
import LinkButton from './ComponentLinkButton';
import SubmitButton from './ComponentSubmitButton';
import TicketLink from './Modules/Ticket';
import AuthenticatedMenu from './Modules/UserMenu/AuthenticatedMenu';
import { renderModulesWithStore } from './store/StoreModules';
import '../i18n';
import './Modules/Basket';
import '../documents/Document';
import './Modules/Dashboard';
import './Modules/Permissions';
import './Modules/Signup';
import './Modules/Account';
import './Modules/Lifescore';
const authenticatedMenuElement = document.querySelector('#menu_authenticated');
if (authenticatedMenuElement) {
    render(_jsx(AuthenticatedMenu, { otherUsers: JSON.parse(authenticatedMenuElement.getAttribute('data-other-users')) }), authenticatedMenuElement);
}
const linkButtonElements = document.querySelectorAll('.react-link-button');
if (linkButtonElements.length > 0) {
    linkButtonElements.forEach((element) => {
        var _a, _b, _c, _d;
        render(_jsx(LinkButton, { className: (_a = element.getAttribute('data-className')) !== null && _a !== void 0 ? _a : '', id: (_b = element.getAttribute('data-id')) !== null && _b !== void 0 ? _b : '', title: (_c = element.getAttribute('data-title')) !== null && _c !== void 0 ? _c : '', href: (_d = element.getAttribute('data-href')) !== null && _d !== void 0 ? _d : '' }), element);
    });
}
const submitButtonElement = document.getElementById('react-submit-button');
if (submitButtonElement) {
    render(_jsx(SubmitButton, { id: (_a = submitButtonElement.getAttribute('data-id')) !== null && _a !== void 0 ? _a : '', title: (_b = submitButtonElement.getAttribute('data-title')) !== null && _b !== void 0 ? _b : '' }), submitButtonElement);
}
const ticketLinkElement = document.getElementById('react-ticket-link');
if (ticketLinkElement) {
    render(_jsx(TicketLink, { redirectUrl: ticketLinkElement.getAttribute('data-url') }), ticketLinkElement);
}
renderModulesWithStore();
